import { Scale } from "lucide-react";
import { Link } from "@tanstack/react-router";

export function Footer() {
  return (
    <footer className="bg-navy-deep text-primary-foreground">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 md:grid-cols-3 md:px-6">
        <div>
          <div className="flex items-center gap-2">
            <Scale className="h-5 w-5 text-gold" />
            <span className="font-bold tracking-wide">VERITAS</span>
          </div>
          <p className="mt-3 max-w-xs text-sm text-white/70">
            Spezialisten für Anlagebetrug und Recovery-Consulting. Wir
            unterstützen Opfer von Online-Scams bei der Wiederbeschaffung ihrer Werte.
          </p>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-gold">Rechtliches</p>
          <ul className="mt-3 space-y-2 text-sm text-white/75">
            <li>
              <Link to="/impressum" className="hover:text-gold">
                Impressum
              </Link>
            </li>
            <li>
              <Link to="/datenschutz" className="hover:text-gold">
                Datenschutzerklärung
              </Link>
            </li>
            <li><a href="#" className="hover:text-gold">Widerrufsbelehrung</a></li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-gold">Kontakt</p>
          <ul className="mt-3 space-y-2 text-sm text-white/75">
            <li>Kontaktformular</li>
            <li>Support: 24/7 Notfall-Hotline</li>
            <li>info@veritasberatung.com</li>
            <li>kontakt@veritasberatung.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/50">
        © 2026 Veritas Rechtsberatung & Consulting. Spezialisten für Anlagebetrug.
      </div>
    </footer>
  );
}